export enum LocalUsoIndicador {
  OrdemServico = 'Ordem Serviço',
  Diagnose = 'Diagnose',
  TipoAplicacao = 'Tipo Aplicação'
}
